module.exports = __webpack_public_path__ + "static/img/12.2c88355.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/12.png
// module id = 4BDF
// module chunks = 0